import React, { useCallback, useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import DraggableMcq from "./DraggableMcq";
import { useSearchParams, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import bgImage from "../../assets/images/bg-img.jpg";
import { FaSave } from "react-icons/fa";
import Loading from "../../Components/loading";

const SetUpMCQ = () => {
  const [loading, setLoading] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [shouldReset, setShouldReset] = useState(false);
  const [position, setPosition] = useState();
  const [minExperience, setMinExperience] = useState();
  const [maxExperience, setMaxExperience] = useState();
  const [technologies, setTechnologies] = useState();
  const [showRegenerate, setShowRegenerate] = useState(false);
  const [showGenerate, setShowGgenerate] = useState(false);
  const [regenLoading, setRegenLoading] = useState(false);
  const [GeneratedMcqs, setGeneratedMcqs] = useState([]);
  const [generateMoreMcqs, setGenerateMoreMcqs] = useState([]);
  const [addMoreLoading, setAddMoreLoading] = useState(false);
  const [addMoreMcqs, setAddMoreMcqs] = useState(true);
  const [apiCall, setApiCall] = useState(1);
  const [showSave, setShowSave] = useState(false);
  const navigate = useNavigate();
  const [isSaveClicked, setIsSaveClicked] = useState(false);

  const nextStep = () => {
    if (id) {
      navigate(`/setup-interview?id=${id}`);
    }
  };

  const prevStep = () => {
    if (id) {
      navigate(`/create-position?id=${id}`);
    }
  };

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const candidateID = searchParams.get("candidate_id");

  function generateHashSession() {
    const now = new Date();

    // Format: YYYY-MM-DD_HH-MM-SS
    const timestamp = now.toISOString().replace(/[-:.TZ]/g, "_");

    // Generate a random number for uniqueness
    const randomPart = Math.floor(Math.random() * 1e12);

    return `${timestamp}_${randomPart}`;
  }

  useEffect(() => {
    getJob();
  }, []);

  const getJob = async () => {
    try {
      setLoading(true);
      console.log(id);

      const response = await axios.get(
        `${process.env.REACT_APP_API_KEY}/get_job?jd_id=${id}`,
        {
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
          }
        }
      );
      setMaxExperience(response?.data?.job?.max_experience);
      setMinExperience(response?.data?.job?.min_experience);
      setPosition(response?.data?.job?.job_title);
      setTechnologies(response?.data?.job?.required_skills);
      console.log("Job Data:", response.data);
    } catch (err) {
      console.error("Error fetching job:", err);
    } finally {
      setLoading(false);
      setShowSave(true);
    }
  };

  useEffect(() => {
    if (shouldReset) {
      resetQuestions();
    }
  }, [shouldReset]);

  const resetQuestions = () => {
    setGenerateMoreMcqs([]);
    setGeneratedMcqs([]);
    setShowRegenerate(false);
    setQuestions([]);
    setShouldReset(false);
    setAddMoreMcqs(false);
  };

  useEffect(() => {
    getMcqQuestions();
  }, []);

  const getMcqQuestions = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_KEY}/get_mcq?jd_id=${id}`,
        {
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
          }
        }
      );
      const formattedQuestions = response.data.question_answer_pairs.map(
        (item) => {
          return {
            question: item.question,
            options: [
              item.option_1,
              item.option_2,
              item.option_3,
              item.option_4,
            ].filter(Boolean), // Remove empty options
            correctAnswer: [
              item.option_1,
              item.option_2,
              item.option_3,
              item.option_4,
            ].indexOf(item.correct_answer), // Get index of correct answer
          };
        }
      );

      setQuestions(() => [...formattedQuestions]);
      setShowRegenerate(true);
    } catch (error) {
      console.error("Error fetching MCQs:", error);
    } finally {
      setShowSave(true);
      setLoading(false);
    }
  };

  const moveQuestion = useCallback((fromIndex, toIndex) => {
    setQuestions((prev) => {
      const updatedQuestions = [...prev];
      const [movedItem] = updatedQuestions.splice(fromIndex, 1);
      updatedQuestions.splice(toIndex, 0, movedItem);
      return updatedQuestions;
    });
  }, []);

  const addMcq = () => {
    setQuestions([
      ...questions,
      { question: "", options: ["A)", "B)", "C)", "D)"], correctAnswer: 0 },
    ]);
    setShowRegenerate(true);
    setShowSave(true);
  };

  const GenerateMcqs = async () => {
    setLoading(true);
    try {
      const data = {
        // input_content: `Generate exactly ten MCQs with correct answers for a candidate proficient in ${
        //   technologies ? technologies : "React and Node.js"
        // }, having experience between ${
        //   minExperience ? minExperience : "2"
        // } and ${
        //   maxExperience ? maxExperience : "5"
        // } years, and applying for the ${
        //   position ? position : "Software Engineer"
        // } role. Give me response in such a way that each option should be in single separate line. With Question number as well.`,
        input_content: `Generate 5 MCQs with answers for a ${technologies ? technologies : "React and Node.js"}-proficient position ${position ? position : "Software Engineer"} with minExperience ${minExperience ? minExperience : "2"} and maxExperience ${maxExperience ? maxExperience : "5"} years of experience .`,
        api_call: apiCall,
        hash_session: generateHashSession(),
      };

      // const data = {
      //   input_content: `Generate exactly ten MCQs with correct answers for a candidate proficient in ${
      //     technologies ? technologies : "React and Node.js"
      //   }, having experience between ${
      //     minExperience ? minExperience : "2"
      //   } and ${
      //     maxExperience ? maxExperience : "5"
      //   } years, and applying for the ${
      //     position ? position : "Software Engineer"
      //   } role. Each question must have 4 unique options A B C D listed on separate lines and The correct_answer field should match exactly one of the provided options eg B Option text here and Do not prefix the correct_answer with Question X or any extra text.`,
      //   api_call: apiCall,
      //   hash_session: generateHashSession(),
      // };

      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/fetch_mcq_questions`,
        data,
        { headers: { "Content-Type": "application/json" } }
      );

      console.log(response.data, "****response*****");

      // Transform response into the expected format
      const formattedQuestions = response.data.question_answer_pairs.map(
        (item) => {
          return {
            question: item.question,
            options: [
              item.option_1,
              item.option_2,
              item.option_3,
              item.option_4,
            ].filter(Boolean), 
            correctAnswer: [
              item.option_1,
              item.option_2,
              item.option_3,
              item.option_4,
            ].indexOf(item.correct_answer),
          };
        }
      );

      // Update the state
      setQuestions((prevQuestions) => [
        ...prevQuestions,
        ...formattedQuestions,
      ]);
    } catch (error) {
      console.log(error, "*****Error******");
      toast.error("Failed to fetch MCQs", {
        style: { backgroundColor: "red", color: "white" },
      });
    } finally {
      setShowRegenerate(true);
      setGenerateMoreMcqs(false);
      setAddMoreMcqs(true);
      setLoading(false);
      setShowSave(true);
    }
  };

  const regenerateMcqs = async () => {
    setRegenLoading(true);
    try {
      setGeneratedMcqs([]);
      setGenerateMoreMcqs([]);

      const data = {
        input_content: `Generate 5 unique and non-repetitive MCQs with answers for a ${technologies ? technologies : "React and Node.js"}-proficient position ${position ? position : "Software Engineer"} with minExperience ${minExperience ? minExperience : "2"} and maxExperience ${maxExperience ? maxExperience : "5"} years of experience . Ensure the questions are new each time and cover both conceptual and practical aspects.`,
        api_call: apiCall,
        hash_session: generateHashSession(),
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/fetch_mcq_questions`,
        data,
        { headers: { "Content-Type": "application/json" } }
      );
      const formattedQuestions = response.data.question_answer_pairs.map(
        (item) => {
          return {
            question: item.question,
            options: [
              item.option_1,
              item.option_2,
              item.option_3,
              item.option_4,
            ].filter(Boolean), // Remove empty options
            correctAnswer: [
              item.option_1,
              item.option_2,
              item.option_3,
              item.option_4,
            ].indexOf(item.correct_answer), // Get index of correct answer
          };
        }
      );

      setQuestions((prevQuestions) => [
        // ...prevQuestions,
        ...formattedQuestions,
      ]);
      setApiCall(apiCall + 1);
    } catch (error) {
      console.error(error, "*****Error in Regenerating MCQs*****");
      toast.error("Failed to regenerate MCQs", {
        style: { backgroundColor: "red", color: "white" },
      });
    } finally {
      setGeneratedMcqs(false);
      setAddMoreMcqs(true);
      setRegenLoading(false);
      setShowSave(true);
    }
  };

  const addGenerateMoreQuestions = (MCQs) => {
    console.log(GeneratedMcqs, "*****Generated MCQs*****");
    MCQs
      ? setGenerateMoreMcqs([...generateMoreMcqs, ...MCQs])
      : setGenerateMoreMcqs([...generateMoreMcqs, ...GeneratedMcqs]);
  };

  const addMoreQuestions = async () => {
    setAddMoreLoading(true);
    setLoading(true);
    try {
      const data = {
       input_content: `Generate 5 unique and non-repetitive MCQs with answers for a ${technologies ? technologies : "React and Node.js"}-proficient position ${position ? position : "Software Engineer"} with minExperience ${minExperience ? minExperience : "2"} and maxExperience ${maxExperience ? maxExperience : "5"} years of experience . Ensure the questions are new each time and cover both conceptual and practical aspects.`,
        api_call: apiCall,
        hash_session: generateHashSession(),
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/fetch_mcq_questions`,
        data,
        { headers: { "Content-Type": "application/json" } }
      );

      const formattedQuestions = response.data.question_answer_pairs.map(
        (item) => {
          return {
            question: item.question,
            options: [
              item.option_1,
              item.option_2,
              item.option_3,
              item.option_4,
            ].filter(Boolean), // Remove empty options
            correctAnswer: [
              item.option_1,
              item.option_2,
              item.option_3,
              item.option_4,
            ].indexOf(item.correct_answer), // Get index of correct answer
          };
        }
      );

      setQuestions((prevQuestions) => [
        ...prevQuestions,
        ...formattedQuestions,
      ]);

      setApiCall(apiCall + 1);
    } catch (error) {
      console.error(error, "*****Error in Adding More MCQs*****");
      toast.error("Failed to add more MCQs", {
        style: { backgroundColor: "red", color: "white" },
      });
    } finally {
      setAddMoreLoading(false);
      setAddMoreMcqs(false);
      setLoading(false);
      setShowSave(true);
    }
  };

  const removeMcq = (index) => {
    setQuestions(questions.filter((_, idx) => idx !== index));
    setShowSave(true);
  };

  const handleChange = (index, field, value) => {
    const updatedQuestions = [...questions];
    if (field.startsWith("options.")) {
      const optionIndex = parseInt(field.split(".")[1]);
      updatedQuestions[index].options[optionIndex] = value;
    } else {
      updatedQuestions[index][field] = value;
    }
    setQuestions(updatedQuestions);
    setShowSave(true);
  };

  const saveMcq = async () => {
    setLoading(true);

    // Validate if all options are filled
    for (const q of questions) {
      if (q.options.some((opt) => opt.trim() === "")) {
        toast.error("All options must be filled before saving.", {
          style: { backgroundColor: "red", color: "white" },
        });
        setLoading(false);
        return;
      }
    }

    const formattedQuestions = questions.map((q) => {
      const optionKeys = ["A", "B", "C", "D"];
      return {
        question: q.question,
        options: {
          A: q.options[0],
          B: q.options[1],
          C: q.options[2],
          D: q.options[3],
        },
        answer: optionKeys[q.correctAnswer], // Convert index to letter (A, B, C, D)
      };
    });

    const payload = { questions: formattedQuestions };
    console.log(payload, "*****Save MCQs*****");

    try {
      await axios.post(
        `${process.env.REACT_APP_API_KEY}/save_mcq_questions?jd_id=${id}`,
        { input_mcq_data: payload },
        { headers: { "Content-Type": "application/json" } }
      );
      toast.success("MCQs saved successfully!");
    } catch (error) {
      toast.error("Failed to save MCQs", {
        style: { backgroundColor: "red", color: "white" },
      });
    } finally {
      setShowSave(false);
      setLoading(false);
      setIsSaveClicked(true);
    }
  };

  return (
    <>
      {(loading || regenLoading) && <Loading />}
      <div
        className="px-6 pt-6 pb-10 min-h-[calc(100vh-80px)]"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="relative">
          {/* Title */}
          <div className="flex justify-end gap-4">
            <span className="bg-blue-700 hover:bg-blue-800 text-white px-4 py-3 rounded-lg shadow-md">
              Total Questions: {questions.length}
            </span>
          </div>
          <h2 className="text-2xl font-semibold my-6 text-white text-left">
            Set Up MCQs :
          </h2>

          {/* MCQ List - Fullscreen & Separated */}
          <div className="space-y-6">
            {questions.map((mcq, index) => (
              <div key={index} className="rounded-xl">
                <DraggableMcq
                  id={index}
                  index={index}
                  question={mcq.question}
                  options={mcq.options}
                  correctAnswer={mcq.correctAnswer}
                  moveQuestion={moveQuestion}
                  onChange={handleChange}
                  remove={removeMcq}
                />
              </div>
            ))}
          </div>

          <div className="flex items-center gap-4 mt-6 mb-14">
            <motion.button
              onClick={addMcq}
              className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-3 rounded-lg shadow-md"
              draggable
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Add Custom MCQs
            </motion.button>
            {generateMoreMcqs && !generateMoreMcqs?.length > 0 && (
              <motion.button
                className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-3 rounded-lg shadow-md flex items-center gap-2"
                draggable
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={GenerateMcqs}
                disabled={loading}
              >
                <i class="fa-solid fa-bolt"></i>
                {loading ? "Generating MCQs through AI..." : "Generate MCQs"}
              </motion.button>
            )}
            {showRegenerate && (
              <motion.button
                className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-3 rounded-lg shadow-md flex items-center gap-2"
                draggable
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={regenerateMcqs}
                disabled={regenLoading}
              >
                <i className="fa fa-redo"></i>
                {regenLoading
                  ? "Re-Generating MCQs through AI..."
                  : " Re-Generate MCQs"}
              </motion.button>
            )}
            {questions && questions.length > 0 && (
              <motion.button
                className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-3 flex items-center gap-2 rounded-lg shadow-md"
                draggable
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={addMoreQuestions}
                disabled={addMoreLoading}
              >
                <i className="fa fa-plus"></i>
                {addMoreLoading
                  ? "Generating More MCQs through AI..."
                  : "Add More MCQs"}
              </motion.button>
            )}

            <motion.button
              className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-3 flex items-center gap-2 rounded-lg shadow-md"
              draggable
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => navigate(`/setup-interview?id=${id}`)}
            >
              <i class="fa fa-angle-double-right" aria-hidden="true"></i>
              Skip
            </motion.button>

            {questions.length > 0 && (
              <motion.button
                className="bg-red-600 text-white px-6 py-3 rounded-lg shadow-md flex items-center gap-2"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setShouldReset(true)}
              >
                <i className="fa fa-undo"></i> Reset
              </motion.button>
            )}
          </div>
          <div className="mt-10 flex justify-center">
            {questions.length > 0 && showSave && (
              <motion.button
                className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-3 rounded-lg shadow-md flex items-center gap-2 mb-14"
                draggable
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={saveMcq}
              >
                <FaSave />
                Save
              </motion.button>
            )}
          </div>
        </div>
        <div className=" p-2 flex justify-between items-center fixed bottom-8 left-0 right-0 ">
          <button
            className={`flex items-center gap-2 px-5 py-2  text-white rounded-lg font-medium transition-all bg-blue-700 hover:bg-blue-800`}
            onClick={prevStep}
          >
            <i className="fa fa-arrow-left"></i> Previous
          </button>

          <div className="flex gap-2">
            <motion.button
              className={`flex items-center gap-2 px-5 py-2 text-white  rounded-lg font-medium transition-all${
                isSaveClicked
                  ? " bg-blue-700 hover:bg-blue-800"
                  : " bg-blue-400 cursor-not-allowed"
              }`}
              onClick={nextStep}
              disabled={!isSaveClicked}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Next <i className="fa fa-arrow-right"></i>
            </motion.button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SetUpMCQ;
